import {
  CtmsTaskRepository,
  type CtmsMyTasksResponse,
  type CtmsTaskDetail,
  type CtmsTaskFilters,
  type CtmsTaskStatus,
  type CtmsTaskComment,
} from "../repositories/CtmsTaskRepository";

export class CtmsTaskUseCase {
  constructor(private readonly repo: CtmsTaskRepository) {}

  createTask(
    payload: Parameters<CtmsTaskRepository["createTask"]>[0],
  ): Promise<CtmsTaskDetail> {
    return this.repo.createTask(payload);
  }

  getMyTasks(
    page?: number,
    limit?: number,
    filters?: CtmsTaskFilters,
  ): Promise<CtmsMyTasksResponse> {
    return this.repo.getMyTasks(page, limit, filters);
  }

  getTasksBySource(
    sourceModule: Parameters<CtmsTaskRepository["getTasksBySource"]>[0],
    sourceEntityId: string,
    page?: number,
    limit?: number,
    studyId?: string,
  ): Promise<CtmsMyTasksResponse> {
    return this.repo.getTasksBySource(
      sourceModule,
      sourceEntityId,
      page,
      limit,
      studyId,
    );
  }

  getTaskById(taskId: string): Promise<CtmsTaskDetail> {
    return this.repo.getTaskById(taskId);
  }

  updateStatus(
    taskId: string,
    status: CtmsTaskStatus,
    comment?: string,
  ): Promise<CtmsTaskDetail> {
    return this.repo.updateStatus(taskId, status, comment);
  }

  addComment(taskId: string, comment: string): Promise<CtmsTaskComment> {
    return this.repo.addComment(taskId, comment);
  }
}
